import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchGroups } from '../server/requests';
import useResponseHandler from './useResponseHandler';

const PAGE_SIZE = 100; // temp for test should change pageNumber instead

const useGroupList = ({ groupType, initialPage = 1, enabled = true }) => {
    const [pageNumber, setPage] = useState(initialPage);

    const payload = { pageSize: PAGE_SIZE, pageNumber, type: groupType };

    const { handleResponse } = useResponseHandler({
        requestHandler: fetchGroups,
        payload,
    });

    const { status, data, error, refetch } = useQuery(
        ['groups', groupType, pageNumber],
        handleResponse,
        {
            keepPreviousData: true,
            staleTime: 0,
            enabled: enabled,
        }
    );

    return { data, error, status, setPage, refetch };
};

export default useGroupList;
